export default __webpack_public_path__ + "static/playground-be191e565207a91eeeab89bcaaf97d0d.jpg";